var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockKeyhole = function SvgLockKeyhole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5A2.5 2.5 0 0 1 14.5 8v2h-5V8A2.5 2.5 0 0 1 12 5.5M8 8v2H7c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-6c0-1.103-.897-2-2-2h-1V8a4 4 0 1 0-8 0m-1 3.5h10c.275 0 .5.225.5.5v6c0 .275-.225.5-.5.5H7a.5.5 0 0 1-.5-.5v-6c0-.275.225-.5.5-.5m5.75 2.5a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v2c0 .416.334.75.75.75s.75-.334.75-.75z"
  })));
};
export default SvgLockKeyhole;